/*
  wissen-klaviyo-formular.js
  Meldet ein Formular des Wissensbereichs ueber Klaviyos Client-API an, ohne
  dass der Besucher die Seite verlaesst.

  Zwei Anfragen je Absenden, seit 10.09.2026:

  1. /client/subscriptions   Einwilligung und Listeneintritt. Traegt nur
                             E-Mail, Vorname, Consent und die Liste.
  2. /client/profiles        Das Wissen ueber den Menschen. Ergaenzt Listen
                             (interessen, lead_magnets, src_touches,
                             wissen_anforderungen) statt sie zu ersetzen,
                             und setzt die "zuletzt"-Felder.

  Warum getrennt: Eigenschaften in der Subscription-Anfrage kommen bei
  jemandem, der schon Mitglied der Liste ist, nicht am Profil an (am 07.09.
  gemessen, HTTP 202 und trotzdem keine neuen Werte). Der Profil-Endpunkt
  schreibt immer. Und: die alte Fassung setzte interessen = [wert] und
  loeschte damit jedes vorher gespeicherte Interesse. Wer erst Smart Eating
  und dann How to be healthy zog, hatte danach nur noch longevity.

  Ergaenzen statt Ersetzen laeuft ueber meta.patch_properties.append, das
  Klaviyo am Client-Profil-Endpunkt anbietet. Doppelte Werte haengt Klaviyo
  nicht zweimal an (07.09. gemessen). Reihenfolge bleibt erhalten, deshalb
  ist src_touches[0] der Ersteintritt und braucht kein eigenes Feld.

  Geprueft am 31.08.2026 direkt von hpn-store.de aus:
  - CORS von hpn-store.de gegen a.klaviyo.com/client/* geht durch.
  - "profiles" im Plural wird abgelehnt, richtig ist "profile" im Singular.
  - Die Kopfzeile revision traegt 2026-04-15. Ein Datum in der Zukunft gibt
    404 "Unable to specify a future revision date".

  company_id ist der oeffentliche Schluessel des Kontos und darf im Quelltext
  stehen. Ein privater Schluessel gehoert NIEMALS in den Browser.

  Doppeltes Opt-in: Klaviyo schickt sofort die Bestaetigungsmail. Erst nach
  dem Klick wird die Person Mitglied der Liste, und erst dann startet der
  Flow. Wer schon Mitglied ist, tritt nicht erneut ein und bekommt keine
  neue Buchmail; das loest dieses Skript nicht, das ist Sache der Flows.
*/
(function () {
  'use strict';

  var ENDPUNKT_ANMELDUNG = 'https://a.klaviyo.com/client/subscriptions';
  var ENDPUNKT_PROFIL = 'https://a.klaviyo.com/client/profiles';
  var REVISION = '2026-04-15';

  function melden(form, text, art) {
    var hinweis = form.querySelector('[data-hinweis-feld]');
    if (!hinweis) return;
    hinweis.hidden = false;
    hinweis.textContent = text;
    hinweis.setAttribute('data-art', art);
    hinweis.setAttribute('role', art === 'fehler' ? 'alert' : 'status');
  }

  function wert(form, name) {
    var feld = form.querySelector('[name="' + name + '"]');
    return feld && feld.value ? feld.value.trim() : '';
  }

  /* Anfrage 1: Einwilligung und Listeneintritt. Bewusst ohne properties. */
  function anmeldung(form) {
    var d = form.dataset;
    var profil = {
      email: wert(form, 'email'),
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    var vorname = wert(form, 'vorname');
    if (vorname) profil.first_name = vorname;

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: d.custom_source || 'Wissensbereich',
          profile: { data: { type: 'profile', attributes: profil } }
        },
        relationships: { list: { data: { type: 'list', id: d.liste } } }
      }
    };
  }

  /* Anfrage 2: das Wissen ueber den Menschen.
     "zuletzt"-Felder werden gesetzt, Listen werden ergaenzt. */
  function profilwissen(form, jetzt) {
    var d = form.dataset;
    var quelle = d.quelle || 'wissen';
    var zeit = (jetzt || new Date()).toISOString();

    var setzen = {
      src_last_touch: quelle,
      src_last_touch_at: zeit,
      consent_source: d.einwilligungsquelle || 'wissen'
    };
    var ergaenzen = {
      src_touches: quelle
    };

    if (d.magnet) {
      setzen.lead_magnet_last = d.magnet;
      setzen.lead_magnet_last_at = zeit;
      ergaenzen.lead_magnets = d.magnet;
      /* Jede Anforderung einzeln, mit Zeit: die Historie, die
         lead_magnets allein nicht hat. */
      ergaenzen.wissen_anforderungen = d.magnet + '@' + zeit;
    }

    /* interessen sind fachliche Themen. Ein Projektstatus wie "in-arbeit"
       gehoert nicht hinein, der laeuft ueber data-updates. */
    if (d.interesse && d.interesse !== 'in-arbeit') {
      ergaenzen.interessen = d.interesse;
    }
    if (d.updates === '1') {
      setzen.wissen_updates = true;
    }

    var attribute = { email: wert(form, 'email'), properties: setzen };
    var vorname = wert(form, 'vorname');
    if (vorname) attribute.first_name = vorname;

    return {
      data: {
        type: 'profile',
        attributes: attribute,
        meta: { patch_properties: { append: ergaenzen } }
      }
    };
  }

  function senden(url, form, nutzlast) {
    return fetch(url + '?company_id=' + encodeURIComponent(form.dataset.konto), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(nutzlast)
    });
  }

  function anbinden(form) {
    if (form.dataset.gebunden === '1') return;
    form.dataset.gebunden = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var knopf = form.querySelector('button[type="submit"]');

      /* Ohne Listen-Kennung wird gar nichts geschickt. Sonst liefe die
         Anmeldung ins Leere und der Besucher saehe trotzdem eine
         Erfolgsmeldung. */
      if (!form.dataset.liste) {
        melden(form, form.dataset.textFehler, 'fehler');
        return;
      }

      if (knopf) knopf.disabled = true;
      melden(form, form.dataset.textLaeuft || 'Einen Moment.', 'laeuft');

      var wissen = profilwissen(form);

      /* return nur fuer Tests, der Browser ignoriert den Rueckgabewert */
      return senden(ENDPUNKT_ANMELDUNG, form, anmeldung(form))
        .then(function (r) {
          if (!r.ok) {
            melden(form, form.dataset.textFehler, 'fehler');
            return;
          }
          /* Die Anmeldung ist angenommen, die Bestaetigungsmail unterwegs.
             Das Profilwissen ist zweitrangig fuer den Besucher: klappt es
             nicht, sieht er trotzdem den Erfolg, und wir versuchen es
             einmal erneut. */
          melden(form, form.dataset.textErfolg, 'erfolg');
          form.reset();
          return senden(ENDPUNKT_PROFIL, form, wissen).then(function (p) {
            if (p.ok) return p;
            return senden(ENDPUNKT_PROFIL, form, wissen);
          });
        })
        .catch(function () {
          melden(form, form.dataset.textFehler, 'fehler');
        })
        .finally(function () {
          if (knopf) knopf.disabled = false;
        });
    });
  }

  function start() {
    document.querySelectorAll('form[data-wissen-klaviyo]').forEach(anbinden);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Der Theme-Editor tauscht Sections aus, ohne die Seite neu zu laden. */
  document.addEventListener('shopify:section:load', start);

  /* Nur fuer Tests ausserhalb des Browsers, im Shop ohne Wirkung. */
  if (typeof module === 'object' && module.exports) {
    module.exports = { anmeldung: anmeldung, profilwissen: profilwissen };
  }
})();
